(() => {
  if (window.ciBandRevealInstalled) return;
  window.ciBandRevealInstalled = true;

  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const instances = new Map();

  function setup(root = document) {
    root.querySelectorAll('[data-ci-band-reveal]').forEach(marker => {
      if (instances.has(marker)) return;
      const host = marker.closest('.ca-leather-sequence');
      const bands = host ? [...host.children].filter(node => node.matches('.ca-craft, .ca-soul')) : [];
      if (!host || bands.length !== 2) return;

      if (reducedMotion.matches) return;

      const texture = marker.dataset.texture;
      host.classList.add('ci-band-reveal-ready');
      bands.forEach((band, index) => {
        band.classList.add(index === 0 ? 'ci-band-from-right' : 'ci-band-from-left');
        const curtain = document.createElement('span');
        const roll = document.createElement('span');
        curtain.className = 'ci-leather-curtain';
        roll.className = 'ci-leather-roll';
        curtain.setAttribute('aria-hidden', 'true');
        roll.setAttribute('aria-hidden', 'true');
        band.append(curtain, roll);
      });

      const abort = new AbortController();
      const signal = abort.signal;
      let frame = 0;
      let textureRequested = false;

      function revealVisibleBands() {
        frame = 0;
        const triggerLine = innerHeight * (innerWidth < 750 ? .9 : .88);
        const preloadLine = innerHeight * 2.2;
        if (!textureRequested && host.getBoundingClientRect().top < preloadLine) {
          textureRequested = true;
          if (texture) host.style.setProperty('--ci-leather-texture', `url("${texture}")`);
        }
        bands.forEach(band => {
          const rect = band.getBoundingClientRect();
          if (rect.top <= triggerLine && rect.bottom >= 0) band.classList.add('is-ci-band-open');
        });
      }

      function queueReveal() {
        if (!frame) frame = requestAnimationFrame(revealVisibleBands);
      }

      window.addEventListener('scroll', queueReveal, {passive:true, signal});
      window.addEventListener('resize', queueReveal, {passive:true, signal});
      window.addEventListener('load', queueReveal, {once:true, signal});
      requestAnimationFrame(() => requestAnimationFrame(revealVisibleBands));

      const fallback = setTimeout(() => {
        bands.forEach(band => {
          const rect = band.getBoundingClientRect();
          if (rect.top < innerHeight && rect.bottom > 0) band.classList.add('is-ci-band-open');
        });
      }, 1600);

      instances.set(marker, () => {
        abort.abort();
        clearTimeout(fallback);
        cancelAnimationFrame(frame);
        instances.delete(marker);
      });
    });
  }

  setup();
  document.addEventListener('shopify:section:load', event => setup(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [marker, dispose] of instances) if (event.target.contains(marker)) dispose();
  });
})();
